(() => {
  const root = document.querySelector('[data-catalog-product-detail]');
  const catalog = window.BARN_STABLE_LX_CATALOG;
  if (!root || !catalog) return;

  const detailBase = window.BARN_STABLE_PRODUCT_DETAIL_PATH || 'product.html';
  const assets = window.BARN_STABLE_PRODUCT_DETAIL_ASSETS || {
    families: {
      sheet420: { aplus: ['assets/hero-aplus-420d.jpg', 'assets/aplus-sheet-performance.jpg', 'assets/aplus-sheet-craft.jpg', 'assets/aplus-sheet-colors.jpg'], size: 'assets/size-horse-sheet.png' },
      sheet600: { aplus: ['assets/hero-aplus-600d.jpg', 'assets/aplus-sheet-performance.jpg', 'assets/aplus-sheet-craft.jpg', 'assets/aplus-sheet-colors.jpg'], size: 'assets/size-horse-sheet.png' },
      mesh: { aplus: ['assets/hero-aplus-summer-mesh.jpg', 'assets/amazon-B0GZF4K152-a-plus-01.jpg', 'assets/aplus-mesh-breathability.jpg'], size: 'assets/size-horse-sheet.png' },
      winter600: { aplus: ['assets/aplus-sheet-performance.jpg', 'assets/aplus-sheet-craft.jpg', 'assets/aplus-sheet-colors.jpg'], size: 'assets/size-horse-sheet.png' },
      winter1680: { aplus: ['assets/aplus-sheet-craft.jpg', 'assets/aplus-sheet-colors.jpg'], size: 'assets/size-horse-sheet.png' },
      muzzle: { aplus: ['assets/hero-aplus-grazing-muzzle.jpg', 'assets/aplus-muzzle-hero.jpg', 'assets/aplus-muzzle-material.jpg', 'assets/aplus-muzzle-colors.jpg'], size: 'assets/size-grazing-muzzle.png' },
      flyMask: { aplus: ['assets/hero-aplus-fly-mask.jpg', 'assets/aplus-mask-comfort.jpg', 'assets/aplus-mask-coverage.jpg', 'assets/aplus-mask-detail.jpg', 'assets/aplus-mask-material.jpg'], size: 'assets/size-fly-mask.png' },
      girth: { aplus: ['assets/hero-aplus-girth.jpg'], size: 'assets/size-western-girth.png' },
      spurs: { gallery: ['assets/detail-spurs-pair.jpg'], size: 'assets/size-training-spurs.jpg' },
      bits: { gallery: ['assets/detail-bits-material.jpg'], size: 'assets/size-snaffle-bits.jpg' },
      groomingTote: { gallery: ['assets/detail-grooming-tote-colors.jpg'], size: 'assets/size-grooming-tote.jpg' },
      meshGrooming: { gallery: ['assets/detail-mesh-grooming-bag.jpg', 'assets/detail-mesh-grooming-use.jpg'], size: 'assets/size-mesh-grooming-bag.jpg' },
      hayBag: { gallery: ['assets/detail-hay-bag-stable.jpg'], size: 'assets/size-hay-bag.jpg' },
      dogCover: { gallery: ['assets/detail-dog-cover-hammock.jpg', 'assets/detail-dog-cover-cargo.jpg'], size: 'assets/size-dog-cover.jpg' }
    }
  };

  const collectionBySection = {
    'horse-sheets': '/collections/horse-sheets-blankets',
    'grazing-muzzles': '/collections/grazing-muzzles',
    'fly-masks': '/collections/fly-masks',
    'girth-protection': '/collections/girths-horse-boots',
    'saddle-tack': '/collections/saddle-covers-tack',
    'stable-grooming': '/collections/grooming-feeding',
    'travel-seasonal': '/collections/other-equipment'
  };

  const escapeHtml = value => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
  const detailUrl = asin => `${detailBase}?asin=${encodeURIComponent(asin)}`;
  const requestedAsin = new URLSearchParams(window.location.search).get('asin');
  const legacyAsinFamilies = {
    B0G5XHM4F1: 'sheet420',
    B0G5KN8KHF: 'sheet600',
    B0GZF4K152: 'mesh',
    B0D7VTPMLD: 'muzzle',
    B0GTKF953S: 'girth'
  };
  const group = catalog.groups.find(candidate =>
    candidate.items.some(item => item.asin === requestedAsin) ||
    candidate.parents?.includes(requestedAsin) ||
    candidate.family === legacyAsinFamilies[requestedAsin]
  );
  const item = group?.items.find(candidate => candidate.asin === requestedAsin) || group?.items[0];

  if (!group || !item) {
    root.innerHTML = `<section class="catalog-detail-empty"><p>BARN &amp; STABLE / Product detail</p><h1>Choose a product to continue.</h1><span>This detail page opens from a product card in the equipment catalog.</span><a href="/pages/equipment-wall">Browse all equipment →</a></section>`;
    return;
  }

  const section = catalog.sections.find(candidate => candidate.id === group.section);
  const familyAssets = assets.families?.[group.family] || {};
  const productName = item.productName || group.title;
  const collectionUrl = collectionBySection[group.section] || '/pages/equipment-wall';
  const groupSizes = [...new Set(group.items.flatMap(candidate => candidate.sizes || []))];
  const sizes = item.sizes?.length ? item.sizes : (groupSizes.length ? groupSizes : ['See current listing']);
  const colorways = group.items.filter(candidate => candidate.imageVerified !== false);
  const priceMeta = item.listPrice ? `List ${item.listPrice}` : (item.status || 'Current Amazon listing');
  const imageCount = 1 + (familyAssets.aplus?.length || 0) + (familyAssets.gallery?.length || 0);
  const productPageUrl = new URL(window.location.href);
  productPageUrl.search = `?asin=${encodeURIComponent(item.asin)}`;
  const absoluteProductImage = new URL(item.image, window.location.origin).href;
  const pageDescription = `${productName} in ${item.color}. Review current colors, fit guidance and the reference price before continuing to Amazon.`;

  document.title = `${productName} — ${item.color} — BARN & STABLE`;
  document.querySelector('link[rel="canonical"]')?.setAttribute('href', productPageUrl.href);
  const updateMeta = (selector, value) => document.querySelector(selector)?.setAttribute('content', value);
  updateMeta('meta[name="description"]', pageDescription);
  updateMeta('meta[property="og:title"]', document.title);
  updateMeta('meta[property="og:description"]', pageDescription);
  updateMeta('meta[property="og:url"]', productPageUrl.href);
  updateMeta('meta[property="og:type"]', 'product');
  updateMeta('meta[property="og:image"]', absoluteProductImage);
  updateMeta('meta[name="twitter:title"]', document.title);
  updateMeta('meta[name="twitter:description"]', pageDescription);
  updateMeta('meta[name="twitter:image"]', absoluteProductImage);

  const productSchema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: productName,
    description: pageDescription,
    image: [absoluteProductImage],
    brand: { '@type': 'Brand', name: 'BARN & STABLE' },
    sku: item.sku || item.asin,
    mpn: item.asin,
    color: item.color,
    url: productPageUrl.href
  };
  const numericPrice = String(item.price || '').replace(/[^0-9.]/g, '');
  if (numericPrice) {
    productSchema.offers = {
      '@type': 'Offer',
      url: item.amazon,
      priceCurrency: 'USD',
      price: numericPrice,
      availability: 'https://schema.org/InStock',
      itemCondition: 'https://schema.org/NewCondition'
    };
  }
  const schemaScript = document.createElement('script');
  schemaScript.type = 'application/ld+json';
  schemaScript.id = 'CatalogProductStructuredData';
  schemaScript.textContent = JSON.stringify(productSchema);
  document.head.appendChild(schemaScript);

  const colorwayMarkup = colorways.map(candidate => `<a class="product-colorway${candidate.asin === item.asin ? ' is-selected' : ''}" href="${detailUrl(candidate.asin)}"${candidate.asin === item.asin ? ' aria-current="page"' : ''}>
    <img src="${escapeHtml(candidate.image)}" alt="${escapeHtml(candidate.color)}" loading="lazy" decoding="async">
    <span>${escapeHtml(candidate.color)}</span>
  </a>`).join('');

  const aplusMarkup = (familyAssets.aplus || []).map((image, index) => `<figure class="${index === 0 ? 'is-wide' : ''}">
    <img src="${escapeHtml(image)}" alt="${escapeHtml(productName)} product detail ${index + 1}" loading="lazy" decoding="async">
    <figcaption>${String(index + 1).padStart(2, '0')} / Product detail</figcaption>
  </figure>`).join('');

  const galleryMarkup = (familyAssets.gallery || []).map((image, index) => `<figure class="${index === 0 && familyAssets.gallery.length === 1 ? 'is-wide' : ''}">
    <img src="${escapeHtml(image)}" alt="${escapeHtml(productName)} product view ${index + 1}" loading="lazy" decoding="async">
    <figcaption>${String(index + 1).padStart(2, '0')} / Product view</figcaption>
  </figure>`).join('');

  root.innerHTML = `<div class="product-detail-page catalog-detail-page">
    <nav class="product-breadcrumbs" aria-label="Breadcrumb">
      <a href="/">Home</a><span>/</span><a href="${collectionUrl}">${escapeHtml(section?.title || 'Equipment')}</a><span>/</span><span aria-current="page">${escapeHtml(item.color)}</span>
    </nav>
    <section class="product-detail-hero">
      <div class="product-detail-gallery">
        <div class="product-main-media">
          <img id="ProductMainImage" src="${escapeHtml(item.image)}" alt="${escapeHtml(`${productName} — ${item.color}`)}" width="1600" height="1600" loading="eager" decoding="async">
          <span class="product-media-index">01 / ${String(imageCount).padStart(2, '0')}</span>
        </div>
      </div>
      <div class="product-detail-information">
        <div class="product-information-inner">
          <p class="product-eyebrow">BARN &amp; STABLE / ${escapeHtml(section?.title || 'Horse equipment')}</p>
          <h1>${escapeHtml(productName)}</h1>
          <p class="catalog-selected-color">${escapeHtml(item.color)}</p>
          <div class="product-title-meta">
            <div><small>Reference price</small><strong>${escapeHtml(item.price || 'Check Amazon')}</strong></div>
            <div><small>Amazon ASIN</small><span>${escapeHtml(item.asin)}</span></div>
          </div>
          <section class="product-colorways" aria-labelledby="ProductColorHeading">
            <div class="product-option-heading"><h2 id="ProductColorHeading">Colors</h2><span>${colorways.length} current colorway${colorways.length === 1 ? '' : 's'}</span></div>
            <div class="product-colorway-grid">${colorwayMarkup}</div>
          </section>
          <section class="catalog-detail-sizes" aria-labelledby="ProductSizeHeading">
            <div class="product-option-heading"><h2 id="ProductSizeHeading">Available sizes</h2>${familyAssets.size ? '<a href="#size-guide">View size guide ↓</a>' : '<span>Confirm on Amazon</span>'}</div>
            <div class="product-option-values">${sizes.map(size => `<span class="product-option-value">${escapeHtml(size)}</span>`).join('')}</div>
          </section>
          <div class="product-description"><p>${escapeHtml(group.detail)}. Select the color and review the supplied fit information below. Final price, inventory and delivery are confirmed on Amazon.</p></div>
          <div class="product-purchase-panel">
            <a class="product-amazon-button" href="${escapeHtml(item.amazon)}" data-attribution-family="${escapeHtml(group.family)}" target="_blank" rel="noopener noreferrer"><span>Buy on Amazon</span><b>↗</b></a>
            <p>${escapeHtml(priceMeta)} · Amazon remains the current official purchase channel.</p>
          </div>
          <div class="product-service-grid">
            <div><strong>Fit &amp; care</strong><a href="${familyAssets.size ? '#size-guide' : '/pages/size-care'}">Review guidance →</a></div>
            <div><strong>Questions</strong><a href="mailto:barnnstable@gmail.com">12-hour customer response</a></div>
            <div><strong>Checkout</strong><span>Completed securely on Amazon</span></div>
          </div>
        </div>
      </div>
    </section>
    ${aplusMarkup ? `<section class="product-evidence catalog-detail-evidence" aria-labelledby="ProductEvidenceHeading"><header class="product-evidence-heading"><div><p>Selected A+ details</p><h2 id="ProductEvidenceHeading">Materials, fit and daily use.</h2></div><span>Supplied product imagery is kept with its relevant equipment family.</span></header><div class="product-evidence-grid">${aplusMarkup}</div></section>` : ''}
    ${galleryMarkup ? `<section class="product-evidence catalog-detail-evidence catalog-product-views" aria-labelledby="ProductViewsHeading"><header class="product-evidence-heading"><div><p>Product views / Amazon listing imagery</p><h2 id="ProductViewsHeading">Details at a glance.</h2></div><span>Additional BARN &amp; STABLE product imagery from the current Amazon listing.</span></header><div class="product-evidence-grid">${galleryMarkup}</div></section>` : ''}
    ${familyAssets.size ? `<section class="catalog-size-guide" id="size-guide" aria-labelledby="CatalogSizeHeading"><header><p>Fit reference / Supplied size chart</p><h2 id="CatalogSizeHeading">Measure before ordering.</h2><span>Use the supplied chart as a reference and confirm the selected listing on Amazon.</span></header><img src="${escapeHtml(familyAssets.size)}" alt="${escapeHtml(productName)} size guide" loading="lazy" decoding="async"></section>` : `<section class="catalog-size-reference" id="size-guide" aria-labelledby="CatalogSizeReferenceHeading"><header><p>Product image / Size reference</p><h2 id="CatalogSizeReferenceHeading">Review the selected style.</h2><span>Compare the product image, selected style and current listing specification before ordering.</span></header><div class="catalog-size-reference-grid"><figure><img src="${escapeHtml(item.image)}" alt="${escapeHtml(`${productName} ${item.color} product reference`)}" loading="lazy" decoding="async"><figcaption>${escapeHtml(item.asin)} / Product reference</figcaption></figure><div class="catalog-size-reference-copy"><small>Selected style</small><h3>${escapeHtml(item.color)}</h3><small>Available size or specification</small><div class="product-option-values">${sizes.map(size => `<span class="product-option-value">${escapeHtml(size)}</span>`).join('')}</div><p>Exact measurements, compatibility and availability are confirmed on the current Amazon listing.</p><a href="${escapeHtml(item.amazon)}" data-attribution-family="${escapeHtml(group.family)}" target="_blank" rel="noopener noreferrer">View size details on Amazon ↗</a></div></div></section>`}
  </div>`;
})();
